import { DateWrapper } from 'kuaidong-lib'
import VueRouter, { RouteConfig } from 'vue-router'
import { HomeworkPlanEditService as homeworkPlanEditService } from 'kuaidong-service'
import { GlobalConfigRouteMetaEnum, HomeworkSummaryType, HomeworkTemplate } from 'kuaidong-model'

const DrillReport = () => import('../views/drill-report/DrillReport.vue')
const HomeworkPoster = () => import('../views/homework/HomeworkPoster.vue')
const HomeworkRecordLayout = () => import('../views/homework/HomeworkRecordLayout.vue')
const HomeworkPlanList = () => import('../views/homework/HomeworkPlanList.vue')
const HomeworkPlanListForLongTerm = () => import('@/views/homework/HomeworkPlanListForLongTerm.vue')
const HomeworkPlanEditGeneral = () => import('../views/homework/HomeworkPlanEditGeneral.vue')
const HomeworkPlanEditItem = () => import('../views/homework/HomeworkPlanEditItem.vue')
const HomeworkComment = () => import('../views/homework/HomeworkComment.vue')
const HomeworkCommentBatch = () => import('../views/homework/HomeworkCommentBatch.vue')
const HomeworkStudentSelectPage = () => import('../views/homework/HomeworkStudentSelect.vue')
const HomeworkDetailPage = () => import('../views/homework/HomeworkDetail.vue')
const HomeworkRecordPage = () => import('../views/homework/HomeworkRecord.vue')
const HomeworkListPage = () => import('../views/homework/HomeworkList.vue')
const HomeworkListExport = () => import('@/views/homework/HomeworkListExport.vue')
const HomeworkStatExport = () => import('@/views/homework/HomeworkStatExport.vue')
const HomeworkSelectExcelTypePage = () => import('@/views/homework/HomeworkSelectExcelTypePage.vue')
const HomeworkReportPoster = () => import('../views/homework/HomeworkReportPoster.vue')
const HomeworkTeacherListPage = () => import('../views/homework-new/HomeworkTeacherList.vue')
const HomeworkClazzListPage = () => import('../views/homework-new/HomeworkClazzList.vue')
const HomeworkTemplates = () => import('../views/homework/HomeworkTemplates.vue')
const HomeworkReminderPoster = () => import('../views/homework/HomeworkReminderPoster.vue')
const HomeworkTopStudents = () => import('../views/homework/HomeworkTopStudents.vue')
const HomeworkUnfinishedStudents = () => import('../views/homework/HomeworkUnfinishStudents.vue')
const HomeworkPlanPreview = () => import('../views/homework/HomeworkPlanPreview.vue')
const HomeworkPlanSuggest = () => import('../views/homework/HomeworkPlanSuggest.vue')
const HomeworkPlanSuggestShare = () => import('../views/homework/HomeworkPlanSuggestShare.vue')
const HomeworkPlanQuestionnaire = () => import('../views/homework/HomeworkPlanQuestionnaire.vue')
const HomeworkDrillReportLayout = () => import('@/views/HomeworkDrillReportLayout.vue')
const HomeworkTemplateMine = () => import('@/views/homework/TemplateMine.vue')
const HomeworkTemplateEdit = () => import('@/views/homework/TemplateEdit.vue')
const HomeworkDrillSelector = () => import('@/views/homework/DrillSelector.vue')

const ExcelDrillSelector = () => import('@/views/homework/ExcelDrillSelector.vue')

const HomeworkDrillDetail = () => import('@/views/homework/HomeworkDrillDetail.vue')
const HomeworkIntelligentPreview = () => import('@/views/homework-intelligent/Preview.vue')
const HomeworkIntelligentPreviewDetail = () => import('@/views/homework-intelligent/PreviewDetail.vue')

const HomeworkIntelligentEditBaseInfo = () =>
  import('../views/homework-intelligent/HomeworkIntelligentEditBaseInfo.vue')
const HomeworkIntelligentEditGeneral = () => import('../views/homework-intelligent/HomeworkIntelligentEditGeneral.vue')
const HomeworkIntelligentEditCoreProject = () =>
  import('../views/homework-intelligent/HomeworkIntelligentEditCoreProject.vue')

const HomeworkPlanGradeSetting = () => import('../views/homework/HomeworkPlanGradeSettings.vue')

const HomeworkPlanCorrecting = () => import('../views/homework/HomeworkPlanCorrecting.vue')
const HomeworkPlanFinishDirection = () => import('../views/homework/HomeworkPlanFinishDirection.vue')

const HomeworkPlanRemindSetting = () => import('../views/homework/HomeworkPlanRemindSetting.vue')

const HomeworkPlanGradesReview = () => import('../views/homework/HomeworkPlanGradesReview.vue')

const GroupLongtermStep1 = () => import('../views/homework/group-longterm/step1.vue')
const GroupLongtermStep2 = () => import('../views/homework/group-longterm/step2.vue')
const GroupLongtermStep3 = () => import('../views/homework/group-longterm/step3.vue')

export const posterRoute: RouteConfig = {
  path: '/homework-poster',
  name: 'homework_poster',
  component: HomeworkPoster,
  props: (route) => ({
    ...route.query,
    ...route.params,
    date: new DateWrapper((route.query.date as string) || new Date()).date,
  }),
  meta: {
    title: '体育作业通知',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

const HomeworkIntelligentRoutes: RouteConfig[] = [
  {
    path: '/homework-intelligent-edit-base-info',
    name: 'intelligent_homework_edit_base_info',
    component: HomeworkIntelligentEditBaseInfo,
    meta: {
      title: '智能作业',
      stepTitle: '基础信息',
      nextStep: 'intelligent_homework_edit_general',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      currentStep: Number(route.query.currentStep),
      totalSteps: Number(route.query.totalSteps),
    }),
  },
  {
    path: '/homework-intelligent-edit-general',
    name: 'intelligent_homework_edit_general',
    component: HomeworkIntelligentEditGeneral,
    meta: {
      title: '智能作业',
      stepTitle: '作业方案',
      nextStep: 'intelligent_homework_edit_core_project',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      currentStep: Number(route.query.currentStep),
      totalSteps: Number(route.query.totalSteps),
    }),
  },
  {
    path: '/homework-intelligent-edit-core-project',
    name: 'intelligent_homework_edit_core_project',
    component: HomeworkIntelligentEditCoreProject,
    meta: {
      title: '智能作业',
      stepTitle: '核心项目',
      nextStep: 'homework_intelligent_preview',
      nextButtonText: '预览',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      currentStep: Number(route.query.currentStep),
      totalSteps: Number(route.query.totalSteps),
    }),
  },
]

export const homeworkRoutes: RouteConfig[] = [
  posterRoute,
  {
    path: '/homework-plan-teacher-list',
    name: 'homework_plan_teacher_list',
    component: HomeworkTeacherListPage,
    meta: {
      title: '布置作业',
      keepAlive: true,
      [GlobalConfigRouteMetaEnum.All]: true,
    },
  },

  {
    path: '/homework-plan-class-list',
    name: 'homework_plan_class_list',
    component: HomeworkClazzListPage,
    meta: {
      title: '作业计划',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
    props: (route) => ({
      ...route.query,
      classId: Number(route.query.classId),
    }),
  },

  {
    path: '/homework-plan-list',
    name: 'homework_plan_list',
    component: HomeworkPlanList,
    meta: {
      title: '布置作业',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
    props: (route) => ({
      classId: Number(route.query.classId),
    }),
  },
  {
    path: '/homework-plan-list-long-term',
    name: 'homework_plan_list_long_term',
    component: HomeworkPlanListForLongTerm,
    meta: {
      title: '布置作业',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
    props: (route) => ({
      classId: Number(route.query.classId),
      id: route.query.id,
    }),
  },

  {
    path: '/homework-plan-preview',
    name: 'homework_plan_preview',
    component: HomeworkPlanPreview,
    meta: {
      title: '作业预览',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      templateId: route.query.templateId,
    }),
  },
  {
    path: '/homework-comment',
    name: 'homework_comment',
    component: HomeworkComment,
    meta: {
      title: '点评作业',
    },
    props: (route) => ({
      userIds: route.query.userIds ? JSON.parse(`${route.query.userIds}`) : [],
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '/homework-comment-batch',
    name: 'homework_comment_batch',
    component: HomeworkCommentBatch,
    meta: {
      title: '点评作业',
    },
    props: (route) => ({
      userIds: route.query.userIds ? JSON.parse(`${route.query.userIds}`) : [],
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '/homework-student-select',
    name: 'homework_student_select',
    component: HomeworkStudentSelectPage,
    meta: {
      title: '选择学生',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '/homework-detail',
    name: 'homework_detail',
    component: HomeworkDetailPage,
    meta: {
      title: '作业详情',
      [GlobalConfigRouteMetaEnum.All]: true,
      keepAlive: true,
    },
    props: (route) => {
      const result = {
        query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
        clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
        completeCount: route.query.completeCount ? Number(route.query.completeCount) : 0,
        studentsCount: route.query.studentsCount ? Number(route.query.studentsCount) : 0,
      }

      if (result.query && result.query.date) {
        result.query.date = new DateWrapper(result.query.date).date
      }

      return result
    },
  },
  {
    path: '/homework-record-layout',
    name: 'homework_record_layout',
    component: HomeworkRecordLayout,
    props: (route) => {
      const result = {
        query: JSON.parse(`${route.query.query}`),
        clazz: JSON.parse(`${route.query.clazz}`),
        defaultStudent: JSON.parse(`${route.query.student}`),
        everydayReleaseId: Number(route.query.everydayReleaseId),
      }

      if (result.query && result.query.date) {
        result.query.date = new DateWrapper(result.query.date).date
      }

      return result
    },
    children: [
      {
        path: '/navigable-homework-record',
        name: 'navigable_homework_record',
        component: HomeworkRecordPage,
        meta: {
          title: '个人训练记录',
        },
        props: (route) => {
          const result = {
            query: JSON.parse(`${route.query.query}`),
            clazz: JSON.parse(`${route.query.clazz}`),
            everydayReleaseId: Number(route.query.everydayReleaseId),
            homeworkTitle: route.query.homeworkTitle || '',
            masterType: route.query.masterType || '',
          }

          if (result.query && result.query.date) {
            result.query.date = new DateWrapper(result.query.date).date
          }

          return result
        },
      },
    ],
  },
  {
    path: '/homework-list',
    name: 'homework_list',
    component: HomeworkListPage,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '检查作业',
      keepAlive: true,
    },
  },
  {
    path: '/homework-list-export',
    name: 'homework_list_export',
    component: HomeworkListExport,
    meta: {
      title: '导出数据',
    },
  },
  {
    path: '/homework-select-excel-type',
    name: 'homework_select_excel_type',
    component: HomeworkSelectExcelTypePage,
    props: (route) => ({
      ...route.query,
      ...route.params,
    }),
    meta: {
      title: '选择报表',
    },
  },
  {
    path: '/homework-excel-export',
    name: 'homework_excel_export',
    component: HomeworkStatExport,
    props: (route) => ({
      ...route.query,
      ...route.params,
    }),
    meta: {
      title: '导出数据',
    },
  },
  {
    path: '/export-excel-drill-select-page',
    name: 'export_excel_drill_select_page',
    component: ExcelDrillSelector,
    meta: {
      title: '选择项目',
    },
  },
  {
    path: '/homework-report-poster',
    name: 'homework_report_poster',
    component: HomeworkReportPoster,
    meta: {
      title: '作业日报',
    },
  },
  {
    path: '/homework-templates',
    name: 'homework_templates',
    component: HomeworkTemplates,
    meta: {
      title: '模板选择',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      clazzId: route.query.clazzId ? Number(route.query.clazzId) : undefined,
    }),
  },
  {
    path: '/homework-reminder',
    name: 'homework_reminder',
    component: HomeworkReminderPoster,
    meta: {
      title: '作业提醒',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '/homework-top-students',
    name: 'homework_top_students',
    component: HomeworkTopStudents,
    meta: {
      title: '优秀名单',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '/homework-unfinished-students',
    name: 'homework_unfinished_students',
    component: HomeworkUnfinishedStudents,
    meta: {
      title: '未完成名单',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },

  {
    path: '/',
    name: 'homework_drill_report_layout',
    component: HomeworkDrillReportLayout,
    props: (route) => ({
      id: route.query.id,
      ids: route.query.ids ? JSON.parse(`${route.query.ids}`) : [],
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
    children: [
      {
        path: 'homework-drill-report',
        name: 'homework_drill_report',
        component: DrillReport,
        props: (route) => ({ ...route.query, ...route.params }),
      },
    ],
  },
]

export const homeworkPlanEditGeneralRoute: RouteConfig = {
  path: '/homework-plan-edit-class',
  name: 'homework_plan_edit_class',
  component: HomeworkPlanEditGeneral,
  meta: {
    stepTitle: '作业信息',
    title: '编辑作业',
    nextStep: 'homework_plan_edit_item',
  },
  props: (route) => ({
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
}

export const homeworkPlanEditItemRoute: RouteConfig = {
  path: '/homework-plan-edit-item',
  component: () => import('@/views/homework/SelectorRoot.vue'),
  children: [
    {
      path: '/homework-plan-edit-item',
      name: 'homework_plan_edit_item',
      component: HomeworkPlanEditItem,
      meta: {
        stepTitle: '作业内容',
        title: '编辑作业',
        nextStep: 'homework_plan_preview',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        currentStep: Number(route.query.currentStep),
        totalSteps: Number(route.query.totalSteps),
      }),
    },
    {
      path: 'drills',
      name: 'homework_plan_edit_drills',
      component: HomeworkDrillSelector,
      meta: {
        title: '选择项目',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        ...route.query,
        ...route.params,
        ids: route.query.ids || [],
      }),
    },
    {
      path: 'drill',
      name: 'Homework_drill_detail',
      component: HomeworkDrillDetail,
      meta: {
        title: '项目详情',
      },
      props: (router) => ({
        drillId: router.query.id,
      }),
    },
  ],
}

export const homeworkPlanSuggestRoute: RouteConfig = {
  path: '/homework-plan-suggest',
  name: 'homework_plan_suggest',
  component: HomeworkPlanSuggest,
  props: (route) => ({
    ...route.query,
    ...route.params,
    questionnaireAnswers: JSON.parse(route.query.questionnaireAnswers as string),
  }),
  meta: {
    title: '作业计划',
  },
}

export const homeworkPlanSuggestShareRoute: RouteConfig = {
  path: '/homework-plan-suggest-share',
  name: 'homework_plan_suggest_share',
  component: HomeworkPlanSuggestShare,
  props: (route) => ({
    ...route.query,
    ...route.params,
    questionnaireAnswers: JSON.parse(route.query.questionnaireAnswers as string),
    homeworkPlanTemplateComments: JSON.parse(route.query.homeworkPlanTemplateComments as string),
  }),
  meta: {
    title: '作业计划',
  },
}

export const homeworkPlanQuestionnaireRoute: RouteConfig = {
  path: '/homework-plan-questionnaire',
  name: 'homework_plan_questionnaire',
  component: HomeworkPlanQuestionnaire,
  meta: {
    title: '作业计划',
  },
}

export const homeworkTemplateMineRoute: RouteConfig = {
  path: '/homework-template-mine',
  name: 'homework_template_mine',
  component: HomeworkTemplateMine,
  meta: {
    title: '我的模版',
  },
}

export const homeworkTemplateEditRoute: RouteConfig = {
  path: '/homework-template-edit',
  component: () => import('@/views/homework/SelectorRoot.vue'),
  children: [
    {
      path: '/homework-template-edit',
      name: 'homework_template_edit',
      component: HomeworkTemplateEdit,
      meta: {
        title: '作业模板',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
    },
    {
      path: 'drills',
      name: 'homework_template_edit_drills',
      component: HomeworkDrillSelector,
      meta: {
        title: '选择项目',
      },
      props: (route) => ({
        ids: route.query.ids || [],
        ...route.query,
        ...route.params,
      }),
    },
    {
      path: 'drill',
      name: 'homework_template_drill_detail',
      component: HomeworkDrillDetail,
      meta: {
        title: '项目详情',
      },
      props: (router) => ({
        drillId: router.query.id,
      }),
    },
  ],
}

export const homeworkIntelligentPreviewRoute: RouteConfig = {
  path: '/homework-intelligent-preview',
  name: 'homework_intelligent_preview',
  component: HomeworkIntelligentPreview,
  meta: {
    title: '智能作业',
  },
}

export const homeworkIntelligentPreviewDetailRoute: RouteConfig = {
  path: '/homework-intelligent-preview-detail',
  name: 'homework_intelligent_preview_detail',
  component: HomeworkIntelligentPreviewDetail,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '智能作业',
  },
}

export const homeworkPlanGradeSettingRoute: RouteConfig = {
  path: '/homework-plan-grade-setting',
  name: 'homework_plan_grade_setting',
  component: HomeworkPlanGradeSetting,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '批改设置',
  },
}

export const HomeworkPlanCorrectingRoute: RouteConfig = {
  path: '/homework-plan-correcting',
  name: 'homework_plan_grade_correcting',
  component: HomeworkPlanCorrecting,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '批改设置',
  },
}

export const HomeworkPlanFinishDirectionRoute: RouteConfig = {
  path: '/homework-plan-finish-direction',
  name: 'homework_plan_finish_direction',
  component: HomeworkPlanFinishDirection,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '批改设置',
  },
}

export const HomeworkPlanGradesReviewRoute: RouteConfig = {
  path: '/homework-plan-grades-review',
  name: 'homework_plan_grades_review',
  component: HomeworkPlanGradesReview,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '批改设置',
  },
}

export const HomeworkPlanRemindSettingRoute: RouteConfig = {
  path: '/homework-plan-remind-setting',
  name: 'homework_plan_remind_setting',
  component: HomeworkPlanRemindSetting,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '未完成提醒',
  },
}

export const GroupLongtermStep1Route: RouteConfig = {
  path: '/homework-group-longterm-step1',
  name: 'homework_group_longterm_step1',
  component: GroupLongtermStep1,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '布置作业',
  },
}
export const GroupLongtermStep2Route: RouteConfig = {
  path: '/homework-group-longterm-step2',
  name: 'homework_group_longterm_step2',
  component: GroupLongtermStep2,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '布置作业',
  },
}

export const GroupLongtermStep3Route: RouteConfig = {
  path: '/homework-group-longterm-step3',
  name: 'homework_group_longterm_step3',
  component: GroupLongtermStep3,
  props: (router) => ({ ...router.query }),
  meta: {
    title: '布置作业',
  },
}

// 最佳学生，最佳班级排行
export const HomeworkBestStudentRoute: RouteConfig = {
  path: '/homework-rank-best-students',
  name: 'homework_rank_best_students',
  component: () => import('../views/homework/best-rank/BestStudents.vue'),
  props: (router) => ({ ...router.query }),
  meta: {
    title: '优秀学生榜',
    keepAlive: true,
  },
}

export const HomeworkBestClazzsRoute: RouteConfig = {
  path: '/homework-rank-best-clazzs',
  name: 'homework_rank_best_clazzs',
  component: () => import('../views/homework/best-rank/BestClazzs.vue'),
  props: (router) => ({ ...router.query }),
  meta: {
    title: '优秀班级榜',
    keepAlive: true,
  },
}

export const HomeworkWeekReportIndexListRoute: RouteConfig = {
  path: '/homework-rank-week-report',
  name: 'homework_rank_week_report',
  component: () => import('../views/homework/PageHomeworkWeekReportIndexList.vue'),
  props: (router) => ({ ...router.query }),
  meta: {
    title: '寒假作业周报',
  },
}

export const HomeworkSummaryReportRoute: RouteConfig = {
  path: '/homework-summary-report',
  name: 'homework_summary_report',
  component: () => import('../views/homework/summary-report/PageHomeworkSummaryReport.vue'),
  props: (router) => ({ ...router.query }),
  meta: {
    title: '作业报告',
  },
}

export const HomeworkRankClazzChooseRoute: RouteConfig = {
  path: '/homework-rank-clazz-choose',
  name: 'homework_rank_clazz_choose',
  component: () => import('../views/homework/best-rank/ClazzChoose.vue'),
  props: (router) => ({ ...router.query }),
  meta: {
    title: '班级',
    keepAlive: true,
  },
}

export default [
  ...homeworkRoutes,
  ...HomeworkIntelligentRoutes,
  homeworkPlanEditGeneralRoute,
  homeworkPlanEditItemRoute,
  homeworkPlanSuggestRoute,
  homeworkPlanSuggestShareRoute,
  homeworkPlanQuestionnaireRoute,
  homeworkTemplateMineRoute,
  homeworkTemplateEditRoute,
  homeworkIntelligentPreviewRoute,
  homeworkIntelligentPreviewDetailRoute,
  homeworkPlanGradeSettingRoute,
  HomeworkPlanCorrectingRoute,
  HomeworkPlanFinishDirectionRoute,
  HomeworkPlanRemindSettingRoute,
  HomeworkPlanGradesReviewRoute,
  GroupLongtermStep1Route,
  GroupLongtermStep2Route,
  GroupLongtermStep3Route,
  HomeworkBestStudentRoute,
  HomeworkBestClazzsRoute,
  HomeworkRankClazzChooseRoute,
  HomeworkWeekReportIndexListRoute,
  HomeworkSummaryReportRoute,
]

export function navigateToHomeworkTemplateMine(router: VueRouter) {
  router.push({ name: 'homework_template_mine' })
}

export function navigateToHomeworkList(router: VueRouter, date?: string, type?: HomeworkSummaryType) {
  router.push({ name: 'homework_list', query: { date, type } })
}

export function navigateToHomeworkPlanCreate(router: VueRouter, backLevel = -1, classtype?: number) {
  router.push({
    name: homeworkPlanEditGeneralRoute.name,
    query: {
      currentStep: '1',
      totalSteps: '2',
      backLevel: String(backLevel),
      ...(classtype
        ? {
            classtype: String(classtype),
          }
        : {}),
    },
  })
}

export async function navigateToHomeworkPlanCreateWithTemplate(
  router: VueRouter,
  template: HomeworkTemplate,
  backLevel = -1
) {
  await homeworkPlanEditService.prepareCreateFromTemplate(template)

  navigateToHomeworkPlanCreate(router, backLevel)
}

export function navigateToHomeworkPlanEdit(router: VueRouter, backLevel = -1) {
  router.push({
    name: homeworkPlanEditItemRoute.children![0].name,
    query: {
      currentStep: '2',
      totalSteps: '2',
      backLevel: String(backLevel),
    },
  })
}

export function navigateToHomeworkPlanSuggest(router: VueRouter, questionnaireAnswers: object) {
  router.push({
    name: homeworkPlanSuggestRoute.name,
    query: { questionnaireAnswers: JSON.stringify(questionnaireAnswers) },
  })
}

export function redirectToHomeworkPlanSuggest(router: VueRouter, questionnaireAnswers: object) {
  router.replace({
    name: homeworkPlanSuggestRoute.name,
    query: { questionnaireAnswers: JSON.stringify(questionnaireAnswers) },
  })
}

export function navigateToHomeworkPlanSuggestShare(
  router: VueRouter,
  questionnaireAnswers: object,
  homeworkPlanTemplateComments: object
) {
  router.push({
    name: homeworkPlanSuggestShareRoute.name,
    query: {
      questionnaireAnswers: JSON.stringify(questionnaireAnswers),
      homeworkPlanTemplateComments: JSON.stringify(homeworkPlanTemplateComments),
    },
  })
}

export function redirectToHomeworkPlanSuggestShare(
  router: VueRouter,
  questionnaireAnswers: object,
  homeworkPlanTemplateComments: object
) {
  router.replace({
    name: homeworkPlanSuggestShareRoute.name,
    query: {
      questionnaireAnswers: JSON.stringify(questionnaireAnswers),
      homeworkPlanTemplateComments: JSON.stringify(homeworkPlanTemplateComments),
    },
  })
}

export function navigateToHomeworkPlanQuestionnaire(router: VueRouter) {
  router.push({ name: homeworkPlanQuestionnaireRoute.name })
}

export function navigateToHomeworkTemplateEdit(router: VueRouter, id?: string, backLevel?: string) {
  router.push({ name: homeworkTemplateEditRoute.children![0].name, query: { id, backLevel } })
}

export function navigateToHomeworkIntelligentEidtBase(
  router: VueRouter,
  backLevel = -1,
  currentStep = 1,
  totalSteps = 3,
  classtype = '0'
) {
  router.push({
    name: 'intelligent_homework_edit_base_info',
    query: {
      currentStep: String(currentStep),
      totalSteps: String(totalSteps),
      backLevel: String(backLevel),
      ...(classtype
        ? {
            classtype: String(classtype),
          }
        : {}),
    },
  })
}

export function navigateToHomeworkIntelligentEditGeneral(
  router: VueRouter,
  backLevel = -1,
  currentStep = 1,
  totalSteps = 3
) {
  router.push({
    name: 'intelligent_homework_edit_general',
    query: {
      currentStep: String(currentStep),
      totalSteps: String(totalSteps),
      backLevel: String(backLevel),
    },
  })
}

export function navigateToHomeworkIntelligentCoreProject(router: VueRouter) {
  router.push({ name: 'intelligent_homework_edit_core_project' })
}

export function navigateToHomeworkRankBestClazzs(
  router: VueRouter,
  options: { date?: Date | string; model?: string } = {} as any
) {
  router.push({
    name: HomeworkBestClazzsRoute.name,
    query: {
      date: options.date ? new DateWrapper(options.date).showDateStr : undefined,
      model: options.model || undefined,
    },
  })
}

export function navigateToHomeworkRankBestStudents(
  router: VueRouter,
  classId: number,
  options: { date?: Date | string; model?: string } = {} as any
) {
  router.push({
    name: HomeworkBestStudentRoute.name,
    query: {
      classId: `${classId}`,
      date: options.date ? new DateWrapper(options.date).showDateStr : undefined,
      model: options.model || undefined,
    },
  })
}

export function navigateToHomeworkSummaryReport(
  router: VueRouter,
  options: { date?: Date | string; model?: string } = {} as any,
  classId?: number
) {
  router.push({
    name: HomeworkSummaryReportRoute.name,
    query: {
      classid: `${classId ? classId : ''}`,
      date: options.date ? new DateWrapper(options.date).showDateStr : undefined,
      model: options.model || undefined,
    },
  })
}

export function navigateToHomeworkRankChooseClazzs(
  router: VueRouter,
  options: { date?: Date | string; model?: string; classtype?: string } = {} as any
) {
  router.push({
    name: HomeworkRankClazzChooseRoute.name,
    query: {
      date: options.date ? new DateWrapper(options.date).showDateStr : undefined,
      model: options.model || undefined,
      classtype: options.classtype,
    },
  })
}
